<template lang='pug'>
#modal-visualizar-detalhes-alerta
    el-dialog.custom-dialog(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='85%',
        v-loading='isLoading'
    )
        template(slot='title')
            div.dialog-header
                | {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoEmLote') }}
            p
                | {{ $t('mensagens.diagnosticoSocioambiental.inserirArquivoXls') }}
            p
                span {{ $t('mensagens.menuMapa.planilha.observacoes.planilhaModelo') }}
                span(@click='downloadModeloPlanilha', style='cursor: pointer')
                    i.el-icon-download.ml-2.mb-1.font-weight-bold(style='color: #00413C;')
                    span(style='color: #00413C') {{ $t('mensagens.menuMapa.planilha.observacoes.baixarPlanilha') }}
        div.body
            div.import-container
                p.sub-title
                    | {{ $t('mensagens.diagnosticoSocioambiental.importarArquivo') }}
                div.import-content
                    p.sub-title-content
                        el-icon.warning-alert-color(:class="'el-icon-warning'")
                        | {{ $t('mensagens.diagnosticoSocioambiental.atencao') }}
                    p
                        | {{ $t('mensagens.diagnosticoSocioambiental.certifiqueQueAsInformacoesEstaoCorretas') }}
                    el-upload.upload-demo(
                        :file-list='fileList',
                        drag,
                        action='alert',
                        :auto-upload='false',
                        :on-change='onLoadFile',
                        :on-remove='onRemoveFile',
                        :on-exceed='onLimitExceed',
                        :limit='1',
                        ref='upload'
                    )
                        i.el-icon-upload(style='margin-top: 40px')
                        .el-upload__text {{ $t('mensagens.diagnosticoSocioambiental.uploadFile.1') }} <em class='custom-em'>{{ $t('mensagens.diagnosticoSocioambiental.uploadFile.2') }}</em>
                        p {{ $t('mensagens.diagnosticoSocioambiental.arquivoNoFormatoXls') }}
            div.result-container
                p.sub-title
                    | {{ $t('mensagens.diagnosticoSocioambiental.resultadoDiagnostico') }}
                div.result-content
                    el-table.sizing-overflow(:data="tableData", border)
                        el-table-column(:label="$t('mensagens.diagnosticoSocioambiental.carDocumento')", prop="CAR/Documento", :formatter='formatTableData')
                        el-table-column(:label="$t('mensagens.diagnosticoSocioambiental.analiseSocioambiental')", prop="Análise Socioambiental", align='center', width='210')
                            template(scope="scope")
                                div.loading-container
                                    el-icon.loading.processing(
                                        v-if="scope.row['Análise Socioambiental'] === 'Processando...'",
                                        slot='icon',
                                        class='el el-icon-loading')
                                    span(v-if="scope.row['Análise Socioambiental'] === 'Processando...'",)
                                        | {{ scope.row['Análise Socioambiental'] }}
                                    el-icon.loading.high(
                                        v-if="scope.row['Análise Socioambiental'] === 'Inconforme'",
                                        slot='icon',
                                        class='mdi mdi-alert-outline')
                                    el-icon.loading.medium(
                                        v-if="scope.row['Análise Socioambiental'] === 'Com alerta'",
                                        slot='icon',
                                        class='mdi mdi-alert-outline')
                                    el-icon.loading.success(
                                        v-if="scope.row['Análise Socioambiental'] === 'Conforme'",
                                        slot='icon',
                                        class='mdi mdi-check-circle-outline')
                                    el-icon.loading.failed(
                                        v-if="scope.row['Análise Socioambiental'] === 'Não encontrado'",
                                        slot='icon',
                                        class='mdi mdi-close-circle-outline')
                    div.footer-container
                        p.sub-title-footer
                            | {{ $t('mensagens.diagnosticoSocioambiental.legenda') }}:
                        div.sub-text-footer
                            div
                                span.success(class='mdi mdi-check-circle-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.conforme') }}
                            div
                                span.medium(class='mdi mdi-alert-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.comAlerta') }}
                            div
                                span.high(class='mdi mdi-alert-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.inconforme') }}
                            div
                                span.failed(class='mdi mdi-close-circle-outline')
                                | {{ $t('mensagens.diagnosticoSocioambiental.documentoNaoEncontrado') }}
        el-divider.custom-divider
        footer.footer-content(slot='footer')
            BaseButton.margin-top(@click='fecharModal()', size='big', type='outline')
                | {{ $t('mensagens.comuns.voltar') }}
            BaseButton.margin-top(@click='exportToExcel()', :disabled='!canExport', size='big', type='primary', icon='el-icon-download')
                | {{ $t('mensagens.diagnosticoSocioambiental.exportarResultadoAnalise') }}
        </template>

<script>
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import formatters from '@/utils/formatters';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import DiagnosticoLoteItauMixin from '@/mixins/DiagnosticoLoteItauMixin';

export default {
    name: 'ModalDiagnosticoSociambientalEmLote',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: true
        },
        tableData: {
            type: Array,
            required: false
        },
        exportTable: {
            type: Array,
            required: false
        },
        protocolo: {
            type: String,
            required: false
        }
    },

    mixins: [DiagnosticoLoteItauMixin],

    data() {
        return {
            isLoading: false,
            fileList: [],
            percentage: 0,
            listaDeDocumentos: [],
            canExport: false,
            modeloPlanilha: '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'
        };
    },

    methods: {
        fecharModal() {
            this.$emit('voltar');
        },

        onLimitExceed() {
            this.$notify.warning({
                message: this.$t('mensagens.diagnosticoSocioambiental.somenteUmArquivoPorVez')
            });
        },

        onRemoveFile() {
            this.fileList = [];
        },

        onLoadFile(file) {
            if (this.mxIsItau()) {
                this.mxOnLoadFileItau(file);
            } else {
                if (this.validateFileFormat(file)) {
                const reader = new FileReader();
                this.canExport = false;
                reader.onload = async (e) => {
                    let hasValidInfo = false;
                    const arrayBuffer = e.target.result;
                    const data = new Uint8Array(arrayBuffer);
                    const workbook = XLSX.read(data, { type: 'array' });

                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];

                    const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false });

                    const headerRow = jsonData[0];
                    const carCpfCnpjIndex = headerRow.findIndex(column => column === 'CAR/CPF/CNPJ');

                    if (carCpfCnpjIndex === -1 || jsonData.length <= 1) {
                        this.showWarningMessage();
                        return;
                    }

                    const carCpfCnpjArray = jsonData.slice(1, 5200).map(row => {
                        const value = row[carCpfCnpjIndex].toString().replace(/[^\w\s]/g, '');

                        if (/^\d{11}$/.test(value) || /^\d{14}$/.test(value) || /^[A-Z]{2}\d{7}.+$/.test(value)) {
                            hasValidInfo = true;
                        }

                        return value;
                    });

                    if (!hasValidInfo) {
                        this.showWarningMessage();
                        return;
                    }

                    this.tableData = carCpfCnpjArray.map(item => ({
                        'CAR/Documento': item,
                        'Análise Socioambiental': this.$t('mensagens.diagnosticoSocioambiental.processando')
                    }));

                    this.exportTable = carCpfCnpjArray.map(item => ({
                        'CAR/Documento': item
                    }));

                    for (let i = 0; i < carCpfCnpjArray.length; i++) {
                        this.canExport = false;
                        const item = carCpfCnpjArray[i];
                        let hasAlto = false;
                        let hasMedio = false;
                        let hasBaixo = false;

                        if (/^[A-Z]{2}\d{7}.+$/.test(item)) {
                            try {
                                let dataCAR = null;
                                let diagnosticos = null;
                                const response = await DiagnosticoSocioambientalService.consultar('CODIGOCAR', this.formatCAR(item), true, false, null, this.protocolo);

                                if (response.data) {
                                    dataCAR = response.data.dataCAR[0];
                                    if (dataCAR) {
                                        diagnosticos = dataCAR.diagnosticos;
                                    }
                                }

                                diagnosticos.forEach((diagnostico) => {
                                    const columnName = diagnostico.camada.nome;
                                    this.exportTable[i][columnName] = diagnostico.nivelAlerta;
                                });

                                for (const diagnostico of diagnosticos) {
                                    const priority = diagnostico.nivelAlerta;

                                    if (priority === 'ALTO') {
                                        hasAlto = true;
                                    } else if (priority === 'MEDIO') {
                                        hasMedio = true;
                                    } else if (priority === 'BAIXO') {
                                        hasBaixo = true;
                                    }
                                }

                                const analysisResult = this.determineAnalysisResult(hasAlto, hasMedio, hasBaixo);
                                this.tableData[i]['Análise Socioambiental'] = analysisResult;
                            } catch (error) {
                                this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                            }
                        } else if (/^\d{11}$/.test(item) || /^\d{14}$/.test(item)) {
                            try {
                                let dataCAR = null;
                                const response = await DiagnosticoSocioambientalService.consultar('CPF_CNPJ', item, true, false, null, this.protocolo);

                                if (response.data) {
                                    dataCAR = response.data.dataCAR;
                                }

                                dataCAR.forEach((diagnostico) => {
                                    const columnName = diagnostico.camada.nome;
                                    this.exportTable[i][columnName] = diagnostico.nivelAlerta;
                                });

                                for (const carItem of dataCAR) {
                                    const priority = carItem.nivelAlerta;

                                    if (priority === 'ALTO') {
                                        hasAlto = true;
                                    } else if (priority === 'MEDIO') {
                                        hasMedio = true;
                                    } else if (priority === 'BAIXO') {
                                        hasBaixo = true;
                                    }
                                }

                                const analysisResult = this.determineAnalysisResult(hasAlto, hasMedio, hasBaixo);
                                this.tableData[i]['Análise Socioambiental'] = analysisResult;
                            } catch (error) {
                                this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                            }
                        } else {
                            this.tableData[i]['Análise Socioambiental'] = this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
                        }
                    }
                    this.canExport = true;
                };

                reader.readAsArrayBuffer(file.raw);
            }
            }
        },

        determineAnalysisResult(hasAlto, hasMedio, hasBaixo) {
            if (hasAlto) {
                return this.$t('mensagens.diagnosticoSocioambiental.inconforme');
            } else if (hasMedio) {
                return this.$t('mensagens.diagnosticoSocioambiental.comAlerta');
            } else if (hasBaixo) {
                return this.$t('mensagens.diagnosticoSocioambiental.conforme');
            } else {
                return this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
            }
        },

        showWarningMessage() {
            this.onRemoveFile();
            this.$notify.warning({
                message: this.$t('mensagens.diagnosticoSocioambiental.erro.arquivoInvalido')
            });
        },

        formatTableData(row, column, data, index) {
            if (/^\d{11}$/.test(data) || /^\d{14}$/.test(data)) {
                return formatters.numeralStringFormatToDocumento(data);
            } else if (/^[A-Z]{2}\d{7}.+$/.test(data)) {
                return formatters.formatCar(data);
            } else {
                return data;
            }
        },

        formatCAR(item) {
            return formatters.formatCar(item);
        },

        validateFileFormat(file) {
            const validExtensions = ['.xls', '.xlsx'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.'));

            if (validExtensions.includes(fileExtension)) {
                return true;
            } else {
                this.onRemoveFile();
                this.$notify.error(this.$t('mensagens.diagnosticoSocioambiental.somenteArquivosXlsSaoPermitidos'));
                return false;
            }
        },

        exportToExcel() {
            if (this.mxIsItau()) {
                this.mxExportToExcelItau();
            } else {
                const filename = 'diagnostico-socioambiental-lote.xlsx';
                const headers = this.getUniqueCamadaHeaders(this.exportTable);

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');

                const headersRow = [
                    [' - ', ' - ', this.$t('mensagens.diagnosticoSocioambiental.criticidadeDeAcordoComProtocolo')],
                    [this.$t('mensagens.diagnosticoSocioambiental.itemAnalisado'), this.$t('mensagens.diagnosticoSocioambiental.resultado'), ...headers]
                ];

                worksheet.addRows(headersRow);

                worksheet.getRow(1).eachCell(cell => {
                    cell.font = { bold: true };
                });
                worksheet.getRow(2).eachCell(cell => {
                    cell.font = { bold: true };
                });

                const columnWidths = [
                    { width: 50 },
                    { width: 20 },
                    { width: 40 },
                    ...Array.from({ length: headers.length }, () => ({ width: 25 }))
                ];
                worksheet.columns = columnWidths;

                for (const row of this.exportTable) {
                    const formattedData = this.formatTableData(row, 'CAR/Documento', row['CAR/Documento']);

                    const rowData = [
                        formattedData,
                        this.determineMaxNivelAlerta(row),
                        ...this.extractCamadaValues(row, headers)
                    ];

                    const newRow = worksheet.addRow(rowData);

                    newRow.getCell(1).font = { bold: false };
                }

                workbook.xlsx.writeBuffer().then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                });
            }
        },

        getUniqueCamadaHeaders(data) {
            const headersSet = new Set();
            for (const row of data) {
                for (const key in row) {
                    if (!key.startsWith('CAR/')) {
                        headersSet.add(key);
                    }
                }
            }
            return [...headersSet];
        },

        determineMaxNivelAlerta(row) {
            const levelsPriority = ['ALTO', 'MEDIO', 'BAIXO'];
            for (const level of levelsPriority) {
                for (const key in row) {
                    if (row[key] === level) return this.determineMaxAlert(level);
                }
            }
            return this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
        },

        determineMaxAlert(str) {
            if (str === 'ALTO') {
                return this.$t('mensagens.diagnosticoSocioambiental.inconforme');
            } else if (str === 'MEDIO') {
                return this.$t('mensagens.diagnosticoSocioambiental.comAlerta');
            } else if (str === 'BAIXO') {
                return this.$t('mensagens.diagnosticoSocioambiental.conforme');
            }
            
            return this.$t('mensagens.diagnosticoSocioambiental.naoEncontrado');
        },

        extractCamadaValues(row, headers) {
            const hasNivelAlerta = headers.some(header => row[header]);

            if (!hasNivelAlerta) {
                return headers.map(() =>
                    ' - '
                );
            }

            return headers.map(header => {
                return row[header] ? this.determineMaxAlert(row[header]) : ' - ';
            });
        },

        downloadModeloPlanilha() {
            const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.modeloPlanilha}`;
            const link = document.createElement('a');
            const fileName = 'Modelo_diagnostico_socioambiental_lote.xlsx';
            link.href = linkSource;
            link.download = fileName;
            link.click();
            link.remove();
        }
    }
};
</script>

<style lang='scss' scoped>
#modal-visualizar-detalhes-alerta {

    ::v-deep .el-dialog__body {
        padding: 0px;
    }

    .sizing-overflow {
        height: 360px;
        overflow-y: auto;
    }

    .loading {
        margin-right: 5px;
    }

    .processing {
        font-size: 15px;
    }

    .high {
        color: rgba(236, 50, 50, 1);
        font-size: 20px;
    }

    .failed {
        color: rgba(116, 15, 15, 1);
        font-size: 20px;
    }

    .success {
        color: rgba(53, 145, 56, 1);
        font-size: 20px;
        margin-left: 5px;
    }

    .medium {
        color: rgba(254, 197, 86, 1);
        font-size: 20px;
        overflow-wrap: break-word !important;
    }

    .body {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        height: auto;
        display: flex;
        justify-content: space-between;
    }

    .el-upload__text {
        font-size: 16px;
    }

    .warning-alert-color {
        margin-right: 5px;
        color: rgba(221, 172, 68, 1) !important;
    }

    .custom-em {
        color: rgba(39, 111, 218, 1) !important;
    }

    .sub-text-footer {
        font-size: 14px;
        display: grid;
        grid-template-columns: repeat(3, .8fr) 2fr;
        place-items: center;
        white-space: nowrap;

        div:not(:last-child) {
            padding-right: 20px;
        }

        div:is(:last-child) {
            padding-left: 10px;
        }

        div:not(:first-child) {
            border-left: 1px solid rgba(0, 0, 0, 0.322);
            padding-left: 20px;
        }

        div {
            display: flex;
            align-items: center;

            span {
                padding-right: 3px;
            }
        }
    }

    .sub-title-content {
        font-family: Roboto;
        font-size: 14px;
        color: #000000;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
    }

    .sub-title-footer {
        font-family: Roboto;
        font-size: 14px;
        color: #00413c;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        margin-left: 10px;
    }

    .import-container {
        width: 38%;
        height: 500px;
    }

    .import-content {
        width: 100%;
        padding: 15px;
        height: 90%;
        border: 1px solid rgba(117, 117, 117, 0.247);
        border-radius: 5px;
    }

    .result-container {
        width: 61%;
        height: 500px;
    }

    .result-content {
        width: 100%;
        height: 90%;
        border: 1px solid rgba(117, 117, 117, 0.247);
        border-radius: 5px;
    }

    .footer-content {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .custom-divider {
        margin-bottom: -10px;
        margin-top: 5px;
    }

    .content {
        overflow: auto;
        max-height: 250px;
    }

    .margin-top {
        margin-top: 16px;
    }

    .margin-left {
        margin-left: 20px;
    }

    .custom-cursor {
        cursor: pointer;
    }

    .alert-container {
        line-height: 1rem;
    }

    .alert-footer {
        display: flex;
    }

    .footer-label {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-right: 5px;
        font-size: 13.5px;
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        border-color: blue !important;
        background-color: blue !important;
    }

    .el-radio-button__orig-radio:checked+.el-radio-button__inner::after {
        border-color: blue !important;
        background-color: blue !important;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .radio-group-container {
        max-width: 510px;
        height: 10px;
        display: flex;
        justify-content: space-between;
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
        font-family: 'Roboto', 'sans serif';
    }

    .radio-spacing {
        margin-right: 10px;
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .custom-dialog {
        border-radius: 5px;
    }

    footer {
        display: flex;
        justify-content: flex-end;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .view-title {
        margin-left: 15px;
        font-family: 'Roboto', 'sans serif';
        font-size: 16px;
        font-weight: 500;
    }

    .sub-title {
        font-family: 'Roboto', 'sans serif';
        font-weight: 500;
        color: #000000;
    }

    .alert-title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-top: 35px;
    }

    .alert-description {
        font-family: 'Roboto', 'sans serif';
        color: #000000;
        font-weight: 300;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon>.el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }
}
</style>
